import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { OrderRestaurantBranchResponse } from '../../types/orders';

interface ChangeBranchModalProps {
  isOpen: boolean;
  onClose: () => void;
  onChange: (branchId: number, reason: string) => void;
  branches: OrderRestaurantBranchResponse[];
  currentBranchId?: number;
  loading?: boolean;
}

const ChangeBranchModal: React.FC<ChangeBranchModalProps> = ({
  isOpen,
  onClose,
  onChange,
  branches,
  currentBranchId,
  loading = false
}) => {
  const { t } = useTranslation();
  const [selectedBranchId, setSelectedBranchId] = useState<number | ''>('');
  const [reason, setReason] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedBranchId && typeof selectedBranchId === 'number' && reason.trim()) {
      onChange(selectedBranchId, reason.trim());
    }
  };

  const handleClose = () => {
    setSelectedBranchId('');
    setReason('');
    onClose();
  };

  const availableBranches = branches.filter(branch => branch.id !== currentBranchId);

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={t('modals.changeBranch.title')}>
      <form onSubmit={handleSubmit} className="modal-form">
        <div className="modal-form-group">
          <label htmlFor="branch">{t('modals.changeBranch.selectNewBranch')}</label>
          <select
            id="branch"
            value={selectedBranchId}
            onChange={(e) => setSelectedBranchId(e.target.value ? parseInt(e.target.value) : '')}
            required
            disabled={loading}
          >
            <option value="">{t('modals.changeBranch.chooseBranch')}</option>
            {availableBranches.map((branch) => (
              <option key={branch.id} value={branch.id}>
                {branch.name} - {branch.representativeName}
              </option>
            ))}
          </select>
        </div>

        <div className="modal-form-group">
          <label htmlFor="reason">{t('modals.changeBranch.reasonLabel')}</label>
          <textarea
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={t('modals.changeBranch.reasonPlaceholder')}
            required
            disabled={loading}
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            onClick={handleClose}
            className="modal-button secondary"
            disabled={loading}
          >
            {t('modals.changeBranch.cancel')}
          </button>
          <button
            type="submit"
            className="modal-button primary"
            disabled={loading || !selectedBranchId || !reason.trim()}
          >
            {loading ? t('modals.changeBranch.changing') : t('modals.changeBranch.changeBranch')}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ChangeBranchModal;
